import { isEmpty } from 'lodash';
import { View } from '@shared/components/View';
import { grid } from '@shared/styles';
import { FileUpload } from '@shared/types/fieldValues';
import { isImage } from '@shared/util/media/type';
import { AuditFileListItem } from './AuditFileListItem';

interface FilesProps {
  files: FileUpload[];
  editable: boolean;
  onFileRemoved?(file: FileUpload): void;
}

export function AuditFileList({ files, onFileRemoved, editable }: FilesProps) {
  const filesToShow = files.filter(file => !isImage(file));

  if (isEmpty(filesToShow)) {
    return null;
  }

  return (
    <>
      {filesToShow.map(file => (
        <View key={file.url}>
          <View style={{ height: grid(1) }} />
          <AuditFileListItem
            file={file}
            onClear={() => onFileRemoved?.(file)}
            editable={editable}
          />
        </View>
      ))}
    </>
  );
}
